// AmazonPay banner slides up when scrolling 
$(function () {
  $(window).scroll(function () {
    var scroll = $(this).scrollTop();
    if (scroll > 100) {
      $("#amazonpay_banner").slideUp('200');
      $("#header").addClass("amazonpay-banner--hide");
    } else {
      $("#amazonpay_banner").slideDown('200');
      $("#header").removeClass("amazonpay-banner--hide");
    }
  });
});
